import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'
import TakeBackFirstStepSecondPart from './TakeBackFirstStepSecondPart'
import TakeBackFirstStepFirstPart from './TakeBackFirstStepFirstPart'
import {
  getTakeBackRef,
  getTakeBackProduct,
  ACTIONS,
} from '@/redux/actions/takeBack'
import useTakeBackStyle from '@/components/TakeBack/TakeBack.style'
import { RootState } from '@/redux/reducers/rootReducer'
import { ProductSearch } from './AutoCompleteTakeBack'
import { simplifiedTakeBack, takeBackSelectedProduct } from '@/utils/constants'

type Tprops = ReturnType<typeof mapStateToProps> & {
  prismicTakeBack: any
  handleNextStep: any
  t: any
  setPriceValue: any
  getTakeBackRef: any
  getTakeBackProduct: any
  handleTakeBackProductsInformations: any
  show: any
  setShow: any
  takeBackProductsInformations: any
  currentProductIndex: any
  showCriterion: any
  setShowCriterion: any
  productStateObject: any
  main: any
  lang?: string
}

const mapStateToProps = (state: RootState) => ({
  takeBack: state.takeBack,
})

const mapDispatchToProps = {
  getTakeBackRef: getTakeBackRef,
  getTakeBackProduct: getTakeBackProduct,
}

const TakeBackFirstStep = ({
  prismicTakeBack,
  t,
  handleNextStep,
  getTakeBackRef,
  getTakeBackProduct,
  setPriceValue,
  takeBack,
  handleTakeBackProductsInformations,
  show,
  setShow,
  takeBackProductsInformations,
  currentProductIndex,
  showCriterion,
  setShowCriterion,
  productStateObject,
  main,
  lang,
}: Tprops) => {
  const classes = useTakeBackStyle()
  const [disabledButtonFirstPart, setDisabledButtonFirstPart] = useState(true)
  const [error, setError] = useState(false)
  const [errorReference, setErrorReference] = useState(false)
  // const [isLoadingProduct, setIsLoadingProduct] = useState(false)
  const [searchProduct, setSearchProduct] = useState<ProductSearch>()
  const [referenceNumberValue, setReferenceNumberValue] = useState(
    takeBackProductsInformations[currentProductIndex]?.labelReference
      ? takeBackProductsInformations[currentProductIndex].labelReference
      : ''
  )
  const [selectValue, setSelectValue] = useState(
    takeBackProductsInformations[currentProductIndex]?.lizeeSKU
      ? takeBackProductsInformations[currentProductIndex]?.lizeeSKU
      : ''
  )
  const [productState, setProductState] = useState(
    takeBackProductsInformations[currentProductIndex]?.quality
      ? takeBackProductsInformations[currentProductIndex]?.quality
      : ''
  )
  const entries = Object.entries(productStateObject)
  const [disabledButtonsecondPart, setDisabledButtonsecondPart] = useState(true)

  const handleResponseFirstPart = (event, index) => {
    const tempArray = takeBackProductsInformations[currentProductIndex]
    tempArray.answers[index].answer = event.target.value
    handleTakeBackProductsInformations(true, false, tempArray.answers)
  }

  useEffect(() => {
    const responses = []
    takeBackProductsInformations.length > 0 &&
      takeBackProductsInformations[currentProductIndex]?.answers?.map(
        (availableAnswer) => {
          if (availableAnswer.required) {
            responses.push(availableAnswer.answer)
          }
          if (Object.values(responses).includes('false')) {
            setError(true)
            setDisabledButtonFirstPart(true)
          } else if (Object.values(responses).includes('')) {
            setError(false)
            setDisabledButtonFirstPart(true)
          } else {
            setError(false)
            setDisabledButtonFirstPart(false)
          }
        }
      )
  }, [takeBackProductsInformations])

  const handleShowSecondPart = () => {
    setShow(false)
  }

  useEffect(() => {
    if (
      ((referenceNumberValue === undefined || referenceNumberValue === '') &&
        searchProduct === undefined) ||
      selectValue === '' ||
      productState === ''
    ) {
      setDisabledButtonsecondPart(true)
    } else {
      setDisabledButtonsecondPart(false)
    }
  }, [referenceNumberValue, productState, selectValue])

  const handleReferenceNumberValue = (value) => {
    setReferenceNumberValue(value)
    if (errorReference) setErrorReference(false)
  }

  const handleCheckReference = async (referenceNumberValue) => {
    const refResponse = await getTakeBackRef(referenceNumberValue)
    if (refResponse.type === ACTIONS.GET_TAKE_BACK_REFERENCE_FAILURE) {
      setShowCriterion(false)
      setErrorReference(true)
    } else {
      setErrorReference(false)
      setShowCriterion(true)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (simplifiedTakeBack && takeBackSelectedProduct) {
        if (!searchProduct)
          await handleCheckProduct(Number(takeBackSelectedProduct))
        if (searchProduct) {
          setSelectValue(searchProduct?.variants?.[0].sku)
          setProductState('goodCondition')
          if (selectValue && productState) {
            if (!show) onSubmitFirstStep()
          }
        }
      }
    }

    fetchData()
  }, [searchProduct, selectValue, productState, show])

  const handleCheckProduct = async (productId: number) => {
    const refResponse = await getTakeBackProduct(productId)
    if (refResponse.type === ACTIONS.GET_TAKE_BACK_ID_FAILURE) {
      setErrorReference(true)
      setShowCriterion(false)
    } else {
      setErrorReference(false)
      setShowCriterion(true)
      setSearchProduct(refResponse.response)
    }
  }

  const handleState = (event) => {
    setProductState(event.target.value)
  }

  const handleSelect = (event) => {
    setSelectValue(event.target.value)
  }

  // handle first step answers
  const onSubmitFirstStep = () => {
    const currentVariant = takeBack?.response?.variants?.find(
      (variant) => variant.sku === selectValue
    )
    const currentPrice =
      currentVariant.channelPricings.WEB.pricingTakeBack[productState]
    setPriceValue(currentPrice)
    const currentSizeNumber = currentVariant.newSize?.name
    handleNextStep()
    const productInfos = {
      lizeeSKU: selectValue,
      labelReference: referenceNumberValue,
      quantity: 1,
      quality: productState,
      amount: Number(currentPrice),
      productName: takeBack?.response?.name,
      size: currentSizeNumber,
      image: { path: takeBack?.response?.images?.[0]?.path },
      withoutLabelReference: !!searchProduct,
    }
    handleTakeBackProductsInformations(false, true, productInfos)
  }

  return (
    <div
      className={clsx(
        classes.firstStepFirstPartContainer,
        'takeBack__firstStep__container',
        showCriterion && 'takeBack__firstStep__container--success'
      )}
    >
      {show ? (
        <>
          {takeBackProductsInformations.length > 0 &&
            takeBackProductsInformations[currentProductIndex] &&
            takeBackProductsInformations[currentProductIndex]?.answers?.length >
              0 && (
              <TakeBackFirstStepFirstPart
                data={prismicTakeBack?.data}
                t={t}
                handleResponseFirstPart={handleResponseFirstPart}
                error={error}
                handleShowSecondPart={handleShowSecondPart}
                disabledButtonFirstPart={disabledButtonFirstPart}
                takeBackProductsInformations={takeBackProductsInformations}
                currentProductIndex={currentProductIndex}
              />
            )}
        </>
      ) : (
        <>
          <TakeBackFirstStepSecondPart
            prismicTakeBack={prismicTakeBack}
            t={t}
            onSubmitFirstStep={onSubmitFirstStep}
            errorReference={errorReference}
            disabledButtonsecondPart={disabledButtonsecondPart}
            referenceNumberValue={referenceNumberValue}
            handleReferenceNumberValue={handleReferenceNumberValue}
            selectValue={selectValue}
            handleSelect={handleSelect}
            productState={productState}
            handleState={handleState}
            showCriterion={showCriterion}
            handleCheckReference={handleCheckReference}
            handleCheckProduct={handleCheckProduct}
            takeBack={takeBack}
            entries={entries}
            main={main}
            lang={lang}
            currentProductIndex={currentProductIndex}
          />
        </>
      )}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TakeBackFirstStep)
